import React, { Component } from "react"
import { CircleFlag } from "react-circle-flags"

const languages = [
  { code: "nl", name: "Nederlands" },
  { code: "en", name: "English" },
  { code: "de", name: "Deutsch" },
]

const flagIcons: {
  [key: string]: string
} = {
  nl: "nl",
  en: "gb",
  de: "de",
}

export interface LanguageSwitcherProps {
  currentLanguage: string
}

export class LanguageSwitcher extends Component<LanguageSwitcherProps> {
  render() {
    return (
      <div className="flex items-start justify-start gap-4 max-w-2xl w-full mx-auto px-8 pt-8">
        {languages.map(language => (
          <CircleFlag
            countryCode={flagIcons[language.code] ?? "nl"}
            height={32}
            width={32}
            className={`${
              language.code === this.props.currentLanguage
                ? "opacity-100"
                : "opacity-20"
            } cursor-pointer hover:opacity-80 transition-opacity`}
            onClick={() => {
              // replace the first part of the url with the language code
              const url = window.location.href.replace(
                /\/(nl|en|de)\//,
                `/${language.code}/`
              )
              window.location.href = url
            }}
          />
        ))}
      </div>
    )
  }
}
